import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./warning-md.svg?react";

export const WarningMdIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
